import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PublicNavbar from './PublicNavbar';
import PublicFooter from './PublicFooter';

export default function PublicLayout({ children }) {
  const location = useLocation();

  // Handle cross-page scroll-to from navigation state
  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
      // Clear state so it doesn't re-scroll on re-render
      window.history.replaceState({}, document.title);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.state]);

  return (
    <div className="homepage" style={{ overflowX: 'hidden' }}>
      <PublicNavbar />
      {children}
      <PublicFooter />
    </div>
  );
}
